/*
 *  Collection Page Numbers
 *    Extends the ajax collection page numbers to add some additional functionality
 *
 *  Version:
 *    1.0.0 - 2022/06/30
 */
import { PageNumbers } from '@process-creative/slate-ajax-collection';

export class CollectionPageNumbers extends PageNumbers {

  onPageChange() {
    super.onPageChange();
    let top = $('[data-collection-template-products]').offset().top - $('[data-header]').height() - $('[data-filters-container]').height();
    //Remove height of the sticky header
    $('html,body').animate({ scrollTop: top });
  }
}
